module.exports = __webpack_public_path__ + "static/media/Acc-2a.bc0d7932.png";